import { css } from '@mui/material/styles';
import {
  enterDurationMs,
  enterEasing,
  exitDurationMs,
  exitEasing,
  fadeIn,
  fadeOut,
  riseIn,
  riseOut,
  staggerStepMs,
} from './transitions';

export type StaggeredItemProps = {
  $isLeaving: boolean;
  $order: number;
  $startDelayMs: number;
};

export const staggeredItemAnimation = ({
  $isLeaving,
  $order,
  $startDelayMs,
}: StaggeredItemProps) => css`
  animation: ${$isLeaving ? riseOut : riseIn} ${$isLeaving ? exitDurationMs : enterDurationMs}ms
    ${$isLeaving ? exitEasing : enterEasing} both;
  animation-delay: ${$startDelayMs + $order * staggerStepMs}ms;
  will-change: opacity, transform;

  @media (prefers-reduced-motion: reduce) {
    animation-name: ${$isLeaving ? fadeOut : fadeIn};
    animation-delay: ${$startDelayMs}ms;
  }
`;
